import PropTypes from 'prop-types';
import React, { Fragment } from 'react';
import RosettaFormattedMessage from '../common/rosetta_formatted_message';
import { getSectionConstructor, isMultiProductSection } from '../../utils/sections';
import ProductCarousel from '../article/products/product_carousel';
import Lazy from '../common/lazy';
import {get, isEmpty} from 'lodash';
import { isYoutube } from '../../utils/widgetInspector';

const LAZY_LOAD_CUSHION_PX = 0;

const Section = (props, context) => {
  const SectionComponent = getSectionConstructor(props);
  if (!SectionComponent) {
    return <span />;
  }

  const impressionTracker = get(props.content, 'impressiontracker');
  const isFirstSection = props.sectionIndex === 0;
  const utmSource = get(context, 'location.query.utm_source');

  let referrer = '';
  if (typeof document !== 'undefined') {
    referrer = get(document, 'referrer');
  }

  const shouldAutoplay = !!(isFirstSection
    && (props.type === 'video:external' || props.content.youtube_video_id || isYoutube(props.content.resource))
    && !utmSource
    && (referrer.length === 0 || !props.isInitialPageview));

  let tracker;
  if (impressionTracker) {
    tracker = (
      <Lazy cushion={LAZY_LOAD_CUSHION_PX}>
        <img src={impressionTracker} className="impression-tracker no-content" />
      </Lazy>
    );
  }

  let slideIndicator;
  if (props.isMobileSlideSection) {
    slideIndicator = (
      <div className="mobile-slide-indicator">
        <RosettaFormattedMessage parentFilename={__filename}
          id="index_and_count"
          description="Slide info displaying current slide and total slides"
          defaultMessage="{index} of {count}"
          values={{
            index: props.sectionIndex + 1,
            count: props.sectionsLength
          }}
        />
      </div>
    );
  }

  /*
   * If we have a polyptych we need to manually place the carousel
   * outside of the section to avoid float issues, so we render it in <Sections>
   * If we are on a multi product section <MultiProductSection> renders this
   * Otherwise, it is rendered right here.
   */
  let productCarousel;
  if (!props.polyptychAttributes
    && !isMultiProductSection(props)
    && !isEmpty(props.content.products)) {
    productCarousel = <ProductCarousel {...props} />;
  }

  return (
    <Fragment>
      {tracker}
      {slideIndicator}
      <SectionComponent {...props}
        isSingleProductSection={false}
        isFirstSection={isFirstSection}
        sold_content_type={props.sold_content_type}
        shouldAutoplay={shouldAutoplay}
      />
      {productCarousel}
    </Fragment>
  );
};

Section.propTypes = {
  adsState: PropTypes.object.isRequired,
  type: PropTypes.string.isRequired,
  sections: PropTypes.arrayOf(PropTypes.object),
  content: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.shape({
      impressiontracker: PropTypes.string,
      products: PropTypes.arrayOf(PropTypes.object)
    })
  ]).isRequired,
  polyptychAttributes: PropTypes.object,
  sectionIndex: PropTypes.number,
  sectionsLength: PropTypes.number,
  isDesktopSlideSection: PropTypes.bool,
  isInitialPageview: PropTypes.bool,
  isMobileSlideSection: PropTypes.bool,
  onRightRailArticle: PropTypes.bool,
  onSlideshowArticle: PropTypes.bool,
  shouldDisplayRelatedEntries: PropTypes.bool,
  shouldDisplayMostPopular: PropTypes.bool,
  product_layout: PropTypes.bool.isRequired,
  sold_content_type: PropTypes.string,
  relatedEntries: PropTypes.array
};

Section.contextTypes = {
  location: PropTypes.object
};

Section.defaultProps = {
  adsState: {},
  type: '',
  content: ''
};

export default Section;
